"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _polished = require("polished");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _price = _interopRequireWildcard(require("@gravity/price"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _textPreview = _interopRequireDefault(require("@gravity/text-preview"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _product = require("@nucleo/product");
var _lodash = require("lodash");
require("rc-tooltip/assets/bootstrap_white.css");
var _DateLabel = _interopRequireDefault(require("./DateLabel"));
var _ProductDate = _interopRequireDefault(require("./ProductDate"));
var _ProductHelper = _interopRequireDefault(require("./ProductHelper"));
var _ProductTitle = require("./ProductTitle");
var _utils2 = require("./utils");
var _jsxFileName = "/codebuild/output/src3559094960/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductCardDetails.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1v2gfocvar() {
  var path = "/codebuild/output/src3559094960/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductCardDetails.js";
  var hash = "ad446a6fd069656868b027bf64bc52e07bd8b4c2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3559094960/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductCardDetails.js",
    statementMap: {
      "0": {
        start: {
          line: 32,
          column: 27
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "1": {
        start: {
          line: 33,
          column: 21
        },
        end: {
          line: 33,
          column: 26
        }
      },
      "2": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 36,
          column: 3
        }
      },
      "3": {
        start: {
          line: 34,
          column: 19
        },
        end: {
          line: 34,
          column: 20
        }
      },
      "4": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 77
        }
      },
      "5": {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 37,
          column: 22
        }
      },
      "6": {
        start: {
          line: 40,
          column: 16
        },
        end: {
          line: 87,
          column: 1
        }
      },
      "7": {
        start: {
          line: 42,
          column: 24
        },
        end: {
          line: 42,
          column: 90
        }
      },
      "8": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 55,
          column: 39
        }
      },
      "9": {
        start: {
          line: 80,
          column: 10
        },
        end: {
          line: 80,
          column: 73
        }
      },
      "10": {
        start: {
          line: 89,
          column: 38
        },
        end: {
          line: 96,
          column: 2
        }
      },
      "11": {
        start: {
          line: 98,
          column: 18
        },
        end: {
          line: 125,
          column: 1
        }
      },
      "12": {
        start: {
          line: 107,
          column: 27
        },
        end: {
          line: 107,
          column: 71
        }
      },
      "13": {
        start: {
          line: 108,
          column: 30
        },
        end: {
          line: 108,
          column: 61
        }
      },
      "14": {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 109,
          column: 57
        }
      },
      "15": {
        start: {
          line: 127,
          column: 20
        },
        end: {
          line: 132,
          column: 1
        }
      },
      "16": {
        start: {
          line: 134,
          column: 23
        },
        end: {
          line: 136,
          column: 4
        }
      },
      "17": {
        start: {
          line: 156,
          column: 26
        },
        end: {
          line: 156,
          column: 84
        }
      },
      "18": {
        start: {
          line: 157,
          column: 16
        },
        end: {
          line: 157,
          column: 31
        }
      },
      "19": {
        start: {
          line: 158,
          column: 25
        },
        end: {
          line: 158,
          column: 64
        }
      },
      "20": {
        start: {
          line: 159,
          column: 22
        },
        end: {
          line: 159,
          column: 73
        }
      },
      "21": {
        start: {
          line: 161,
          column: 22
        },
        end: {
          line: 161,
          column: 72
        }
      },
      "22": {
        start: {
          line: 162,
          column: 20
        },
        end: {
          line: 162,
          column: 92
        }
      },
      "23": {
        start: {
          line: 163,
          column: 22
        },
        end: {
          line: 163,
          column: 98
        }
      },
      "24": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 168,
          column: 77
        }
      },
      "25": {
        start: {
          line: 171,
          column: 18
        },
        end: {
          line: 171,
          column: 82
        }
      },
      "26": {
        start: {
          line: 172,
          column: 20
        },
        end: {
          line: 172,
          column: 57
        }
      },
      "27": {
        start: {
          line: 175,
          column: 2
        },
        end: {
          line: 181,
          column: 3
        }
      },
      "28": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 176,
          column: 81
        }
      },
      "29": {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 177,
          column: 48
        }
      },
      "30": {
        start: {
          line: 179,
          column: 4
        },
        end: {
          line: 179,
          column: 73
        }
      },
      "31": {
        start: {
          line: 180,
          column: 4
        },
        end: {
          line: 180,
          column: 44
        }
      },
      "32": {
        start: {
          line: 182,
          column: 2
        },
        end: {
          line: 266,
          column: 4
        }
      },
      "33": {
        start: {
          line: 246,
          column: 14
        },
        end: {
          line: 260,
          column: 17
        }
      },
      "34": {
        start: {
          line: 269,
          column: 0
        },
        end: {
          line: 295,
          column: 2
        }
      },
      "35": {
        start: {
          line: 297,
          column: 0
        },
        end: {
          line: 309,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 32,
            column: 27
          },
          end: {
            line: 32,
            column: 28
          }
        },
        loc: {
          start: {
            line: 32,
            column: 52
          },
          end: {
            line: 38,
            column: 1
          }
        },
        line: 32
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 42,
            column: 15
          },
          end: {
            line: 42,
            column: 16
          }
        },
        loc: {
          start: {
            line: 42,
            column: 24
          },
          end: {
            line: 42,
            column: 90
          }
        },
        line: 42
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 52,
            column: 15
          },
          end: {
            line: 52,
            column: 16
          }
        },
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 55,
            column: 39
          }
        },
        line: 53
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 79,
            column: 22
          },
          end: {
            line: 79,
            column: 23
          }
        },
        loc: {
          start: {
            line: 80,
            column: 10
          },
          end: {
            line: 80,
            column: 73
          }
        },
        line: 80
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 106,
            column: 15
          },
          end: {
            line: 106,
            column: 16
          }
        },
        loc: {
          start: {
            line: 106,
            column: 24
          },
          end: {
            line: 110,
            column: 7
          }
        },
        line: 106
      },
      "5": {
        name: "ProductCardDetails",
        decl: {
          start: {
            line: 141,
            column: 9
          },
          end: {
            line: 141,
            column: 27
          }
        },
        loc: {
          start: {
            line: 155,
            column: 3
          },
          end: {
            line: 267,
            column: 1
          }
        },
        line: 155
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 245,
            column: 13
          },
          end: {
            line: 245,
            column: 14
          }
        },
        loc: {
          start: {
            line: 246,
            column: 14
          },
          end: {
            line: 260,
            column: 17
          }
        },
        line: 246
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 35,
            column: 19
          },
          end: {
            line: 35,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 35,
            column: 34
          },
          end: {
            line: 35,
            column: 64
          }
        }, {
          start: {
            line: 35,
            column: 67
          },
          end: {
            line: 35,
            column: 76
          }
        }],
        line: 35
      },
      "1": {
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 55,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 67
          }
        }, {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 52
          }
        }, {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 55,
            column: 39
          }
        }],
        line: 53
      },
      "2": {
        loc: {
          start: {
            line: 80,
            column: 10
          },
          end: {
            line: 80,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 10
          },
          end: {
            line: 80,
            column: 24
          }
        }, {
          start: {
            line: 80,
            column: 28
          },
          end: {
            line: 80,
            column: 73
          }
        }],
        line: 80
      },
      "3": {
        loc: {
          start: {
            line: 109,
            column: 28
          },
          end: {
            line: 109,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 109,
            column: 28
          },
          end: {
            line: 109,
            column: 38
          }
        }, {
          start: {
            line: 109,
            column: 42
          },
          end: {
            line: 109,
            column: 55
          }
        }],
        line: 109
      },
      "4": {
        loc: {
          start: {
            line: 159,
            column: 22
          },
          end: {
            line: 159,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 22
          },
          end: {
            line: 159,
            column: 36
          }
        }, {
          start: {
            line: 159,
            column: 40
          },
          end: {
            line: 159,
            column: 73
          }
        }],
        line: 159
      },
      "5": {
        loc: {
          start: {
            line: 162,
            column: 20
          },
          end: {
            line: 162,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 162,
            column: 21
          },
          end: {
            line: 162,
            column: 32
          }
        }, {
          start: {
            line: 162,
            column: 36
          },
          end: {
            line: 162,
            column: 57
          }
        }, {
          start: {
            line: 162,
            column: 63
          },
          end: {
            line: 162,
            column: 70
          }
        }, {
          start: {
            line: 162,
            column: 74
          },
          end: {
            line: 162,
            column: 91
          }
        }],
        line: 162
      },
      "6": {
        loc: {
          start: {
            line: 163,
            column: 22
          },
          end: {
            line: 163,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 163,
            column: 23
          },
          end: {
            line: 163,
            column: 34
          }
        }, {
          start: {
            line: 163,
            column: 38
          },
          end: {
            line: 163,
            column: 61
          }
        }, {
          start: {
            line: 163,
            column: 67
          },
          end: {
            line: 163,
            column: 74
          }
        }, {
          start: {
            line: 163,
            column: 78
          },
          end: {
            line: 163,
            column: 97
          }
        }],
        line: 163
      },
      "7": {
        loc: {
          start: {
            line: 171,
            column: 26
          },
          end: {
            line: 171,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 171,
            column: 26
          },
          end: {
            line: 171,
            column: 66
          }
        }, {
          start: {
            line: 171,
            column: 70
          },
          end: {
            line: 171,
            column: 81
          }
        }],
        line: 171
      },
      "8": {
        loc: {
          start: {
            line: 172,
            column: 20
          },
          end: {
            line: 172,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 172,
            column: 20
          },
          end: {
            line: 172,
            column: 32
          }
        }, {
          start: {
            line: 172,
            column: 36
          },
          end: {
            line: 172,
            column: 57
          }
        }],
        line: 172
      },
      "9": {
        loc: {
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 181,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 181,
            column: 3
          }
        }, {
          start: {
            line: 178,
            column: 9
          },
          end: {
            line: 181,
            column: 3
          }
        }],
        line: 175
      },
      "10": {
        loc: {
          start: {
            line: 176,
            column: 28
          },
          end: {
            line: 176,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 176,
            column: 28
          },
          end: {
            line: 176,
            column: 50
          }
        }, {
          start: {
            line: 176,
            column: 54
          },
          end: {
            line: 176,
            column: 80
          }
        }],
        line: 176
      },
      "11": {
        loc: {
          start: {
            line: 179,
            column: 28
          },
          end: {
            line: 179,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 179,
            column: 28
          },
          end: {
            line: 179,
            column: 46
          }
        }, {
          start: {
            line: 179,
            column: 50
          },
          end: {
            line: 179,
            column: 72
          }
        }],
        line: 179
      },
      "12": {
        loc: {
          start: {
            line: 185,
            column: 9
          },
          end: {
            line: 194,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 185,
            column: 9
          },
          end: {
            line: 185,
            column: 18
          }
        }, {
          start: {
            line: 186,
            column: 10
          },
          end: {
            line: 193,
            column: 28
          }
        }],
        line: 185
      },
      "13": {
        loc: {
          start: {
            line: 195,
            column: 9
          },
          end: {
            line: 195,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 195,
            column: 9
          },
          end: {
            line: 195,
            column: 18
          }
        }, {
          start: {
            line: 195,
            column: 22
          },
          end: {
            line: 195,
            column: 37
          }
        }, {
          start: {
            line: 195,
            column: 41
          },
          end: {
            line: 195,
            column: 79
          }
        }],
        line: 195
      },
      "14": {
        loc: {
          start: {
            line: 196,
            column: 9
          },
          end: {
            line: 212,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 196,
            column: 9
          },
          end: {
            line: 196,
            column: 18
          }
        }, {
          start: {
            line: 197,
            column: 10
          },
          end: {
            line: 197,
            column: 22
          }
        }, {
          start: {
            line: 198,
            column: 12
          },
          end: {
            line: 211,
            column: 24
          }
        }],
        line: 196
      },
      "15": {
        loc: {
          start: {
            line: 199,
            column: 15
          },
          end: {
            line: 202,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 199,
            column: 15
          },
          end: {
            line: 199,
            column: 33
          }
        }, {
          start: {
            line: 200,
            column: 16
          },
          end: {
            line: 200,
            column: 35
          }
        }, {
          start: {
            line: 201,
            column: 18
          },
          end: {
            line: 201,
            column: 79
          }
        }],
        line: 199
      },
      "16": {
        loc: {
          start: {
            line: 203,
            column: 15
          },
          end: {
            line: 210,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 203,
            column: 15
          },
          end: {
            line: 203,
            column: 34
          }
        }, {
          start: {
            line: 204,
            column: 16
          },
          end: {
            line: 204,
            column: 33
          }
        }, {
          start: {
            line: 205,
            column: 18
          },
          end: {
            line: 209,
            column: 20
          }
        }],
        line: 203
      },
      "17": {
        loc: {
          start: {
            line: 213,
            column: 9
          },
          end: {
            line: 221,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 213,
            column: 10
          },
          end: {
            line: 213,
            column: 18
          }
        }, {
          start: {
            line: 213,
            column: 22
          },
          end: {
            line: 213,
            column: 30
          }
        }, {
          start: {
            line: 214,
            column: 10
          },
          end: {
            line: 220,
            column: 12
          }
        }],
        line: 213
      },
      "18": {
        loc: {
          start: {
            line: 222,
            column: 9
          },
          end: {
            line: 227,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 222,
            column: 9
          },
          end: {
            line: 222,
            column: 16
          }
        }, {
          start: {
            line: 223,
            column: 10
          },
          end: {
            line: 223,
            column: 20
          }
        }, {
          start: {
            line: 224,
            column: 12
          },
          end: {
            line: 226,
            column: 37
          }
        }],
        line: 222
      },
      "19": {
        loc: {
          start: {
            line: 228,
            column: 9
          },
          end: {
            line: 241,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 228,
            column: 9
          },
          end: {
            line: 228,
            column: 30
          }
        }, {
          start: {
            line: 229,
            column: 10
          },
          end: {
            line: 229,
            column: 24
          }
        }, {
          start: {
            line: 230,
            column: 12
          },
          end: {
            line: 240,
            column: 26
          }
        }],
        line: 228
      },
      "20": {
        loc: {
          start: {
            line: 243,
            column: 9
          },
          end: {
            line: 263,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 243,
            column: 9
          },
          end: {
            line: 243,
            column: 24
          }
        }, {
          start: {
            line: 244,
            column: 10
          },
          end: {
            line: 262,
            column: 29
          }
        }],
        line: 243
      },
      "21": {
        loc: {
          start: {
            line: 244,
            column: 36
          },
          end: {
            line: 244,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 244,
            column: 36
          },
          end: {
            line: 244,
            column: 61
          }
        }, {
          start: {
            line: 244,
            column: 65
          },
          end: {
            line: 244,
            column: 81
          }
        }],
        line: 244
      },
      "22": {
        loc: {
          start: {
            line: 247,
            column: 17
          },
          end: {
            line: 259,
            column: 17
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 248,
            column: 18
          },
          end: {
            line: 252,
            column: 35
          }
        }, {
          start: {
            line: 254,
            column: 18
          },
          end: {
            line: 258,
            column: 19
          }
        }],
        line: 247
      },
      "23": {
        loc: {
          start: {
            line: 249,
            column: 58
          },
          end: {
            line: 249,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 249,
            column: 75
          },
          end: {
            line: 249,
            column: 79
          }
        }, {
          start: {
            line: 249,
            column: 82
          },
          end: {
            line: 249,
            column: 83
          }
        }],
        line: 249
      },
      "24": {
        loc: {
          start: {
            line: 254,
            column: 18
          },
          end: {
            line: 258,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 254,
            column: 18
          },
          end: {
            line: 254,
            column: 29
          }
        }, {
          start: {
            line: 255,
            column: 20
          },
          end: {
            line: 257,
            column: 52
          }
        }],
        line: 254
      },
      "25": {
        loc: {
          start: {
            line: 255,
            column: 58
          },
          end: {
            line: 255,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 255,
            column: 75
          },
          end: {
            line: 255,
            column: 79
          }
        }, {
          start: {
            line: 255,
            column: 82
          },
          end: {
            line: 255,
            column: 83
          }
        }],
        line: 255
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0, 0],
      "6": [0, 0, 0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0, 0],
      "14": [0, 0, 0],
      "15": [0, 0, 0],
      "16": [0, 0, 0],
      "17": [0, 0, 0],
      "18": [0, 0, 0],
      "19": [0, 0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ad446a6fd069656868b027bf64bc52e07bd8b4c2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1v2gfocvar = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1v2gfocvar();
cov_1v2gfocvar().s[0]++;
var themeValueFromArgs = function themeValueFromArgs(theme) {
  cov_1v2gfocvar().f[0]++;
  var currentValue = (cov_1v2gfocvar().s[1]++, theme);
  cov_1v2gfocvar().s[2]++;
  for (var _len = arguments.length, themeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    themeArgs[_key - 1] = arguments[_key];
  }
  for (var index = (cov_1v2gfocvar().s[3]++, 0); index < themeArgs.length; index += 1) {
    cov_1v2gfocvar().s[4]++;
    currentValue = currentValue ? (cov_1v2gfocvar().b[0][0]++, currentValue[themeArgs[index]]) : (cov_1v2gfocvar().b[0][1]++, undefined);
  }
  cov_1v2gfocvar().s[5]++;
  return currentValue;
};
var Wrapper = (cov_1v2gfocvar().s[6]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: function className(props) {
    cov_1v2gfocvar().f[1]++;
    cov_1v2gfocvar().s[7]++;
    return "stx-ProductCardDetails stx-ProductCardDetails-".concat(props.productId);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      display: block;\n      position: relative;\n      overflow: hidden;\n      vertical-align: top;\n      margin: 0.25rem 0 0.25rem 0;\n      padding: 0;\n      color: ", ";\n      &:lang(ar) {\n        text-align: right;\n      }\n    "])), function (props) {
  cov_1v2gfocvar().f[2]++;
  cov_1v2gfocvar().s[8]++;
  return (cov_1v2gfocvar().b[1][0]++, themeValueFromArgs(props.theme, 'product', 'nameTextColor')) || (cov_1v2gfocvar().b[1][1]++, themeValueFromArgs(props.theme, 'textColor')) || (cov_1v2gfocvar().b[1][2]++, _stylingConstants.default.color.baseText);
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      display: block;\n      position: relative;\n      overflow: hidden;\n      padding: 0;\n      color: var(--textColor, #000000);\n      &:lang(ar) {\n        text-align: right;\n      }\n\n      .stx-ProductCardTitle {\n        margin-bottom: 0;\n      }\n\n      .stx-ProductDate {\n        margin-top: 8px\n      }\n\n      .stx-overflow-detect-wrapper {\n        margin-top: ", ";\n        ", ";\n      }\n    "])), function (_ref) {
  var theme = _ref.theme;
  cov_1v2gfocvar().f[3]++;
  cov_1v2gfocvar().s[9]++;
  return (cov_1v2gfocvar().b[2][0]++, theme.spacingY) || (cov_1v2gfocvar().b[2][1]++, "".concat((0, _lodash.get)(_themeMapper.evolutionTheme, 'spacings.xl', 16), "px"));
}, _utils.gMediaQueries.sm(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n          margin-top: 8px;\n        "])))))));
var ProductDescriptionTextPreview = (cov_1v2gfocvar().s[10]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_textPreview.default), (0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    color: var(--subtleTextColor, #7f8c8d);\n  "])), _themeMapper.evolutionTheme.typography.caption1.fontSize, _themeMapper.evolutionTheme.typography.caption1.lineHeight, _themeMapper.evolutionTheme.fontWeight.normal))));
var PriceText = (cov_1v2gfocvar().s[11]++, (0, _utils.withThemedStyles)(_styledComponents.default.span.attrs({
  className: "stx-ProductCardPrice"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      display: block;\n      font-size: ", ";\n      color: ", ";\n      font-weight: normal;\n      margin: 0;\n      padding: 0;\n    "])), _stylingConstants.default.font.sizeM, function (props) {
  cov_1v2gfocvar().f[4]++;
  var themeColor = (cov_1v2gfocvar().s[12]++, themeValueFromArgs(props.theme, 'textColor'));
  var constantColor = (cov_1v2gfocvar().s[13]++, _stylingConstants.default.color.baseText);
  cov_1v2gfocvar().s[14]++;
  return (0, _polished.lighten)(0.2, (cov_1v2gfocvar().b[3][0]++, themeColor) || (cov_1v2gfocvar().b[3][1]++, constantColor));
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n      display: block;\n      margin: 0;\n      padding: 0;\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      color: var(--subtleTextColor, #7f8c8d);\n    "])), _themeMapper.evolutionTheme.typography.caption1.fontSize, _themeMapper.evolutionTheme.typography.caption1.lineHeight, _themeMapper.evolutionTheme.fontWeight.normal))));
var OnSalesFrom = (cov_1v2gfocvar().s[15]++, _styledComponents.default.div.attrs({
  className: 'stx-ProductCard-OnSalesFrom'
})(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  display: inline-block;\n  font-size: ", ";\n"])), _stylingConstants.default.font.sizeS));
var TooltipWrapper = (cov_1v2gfocvar().s[16]++, (0, _styledComponents.default)(_rcTooltip.default).attrs({
  className: "stx-tooltip"
})(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)([""]))));

/*
 * Component to display text details of a product
 */
function ProductCardDetails(_ref2) {
  var _this = this;
  var product = _ref2.product,
    showDate = _ref2.showDate,
    showTime = _ref2.showTime,
    showDescription = _ref2.showDescription,
    showPrice = _ref2.showPrice,
    showTitle = _ref2.showTitle,
    currencyCode = _ref2.currencyCode,
    performance = _ref2.performance,
    timeslot = _ref2.timeslot,
    productTitleFontSize = _ref2.productTitleFontSize,
    replaceProductNameByPerformance = _ref2.replaceProductNameByPerformance,
    intl = _ref2.intl,
    themeQueries = _ref2.themeQueries;
  cov_1v2gfocvar().f[5]++;
  var productSubtitle = (cov_1v2gfocvar().s[17]++, _ProductHelper.default.getProductSubtitle({
    product: product,
    performance: performance
  }));
  var regex = (cov_1v2gfocvar().s[18]++, /(<([^>]+)>)/gi);
  var rawDescription = (cov_1v2gfocvar().s[19]++, (0, _utils2.getRawDescription)(performance, product));
  var description = (cov_1v2gfocvar().s[20]++, (cov_1v2gfocvar().b[4][0]++, rawDescription) && (cov_1v2gfocvar().b[4][1]++, rawDescription.replace(regex, ''))); // STX-100476: Replace html tags of rawDescription
  // STX-100489: Prepare tooltip to display for soldout products when hovering on description
  var htmlTooltip = (cov_1v2gfocvar().s[21]++, (0, _utils2.createDescriptionHtmlTooltip)(performance, product));
  var minAmount = (cov_1v2gfocvar().s[22]++, (cov_1v2gfocvar().b[5][0]++, performance) && (cov_1v2gfocvar().b[5][1]++, performance.minAmount) || (cov_1v2gfocvar().b[5][2]++, product) && (cov_1v2gfocvar().b[5][3]++, product.minAmount));
  var plainAmount = (cov_1v2gfocvar().s[23]++, (cov_1v2gfocvar().b[6][0]++, performance) && (cov_1v2gfocvar().b[6][1]++, performance.plainAmount) || (cov_1v2gfocvar().b[6][2]++, product) && (cov_1v2gfocvar().b[6][3]++, product.plainAmount));

  // TODO : get this value from section and not in labels
  // Define what kind of price should be shown, minimum or plain price
  var displayPlainAmount = (cov_1v2gfocvar().s[24]++, intl.formatMessage({
    id: 'config.gravity.priceInfoDisplay'
  }) === 'PLAIN');

  // "Date to be confirmed" text should only be displayed for sporting events
  var isMatch = (cov_1v2gfocvar().s[25]++, Boolean((cov_1v2gfocvar().b[7][0]++, product.productType === 'SPORTING_EVENT') && (cov_1v2gfocvar().b[7][1]++, performance)));
  var finalDate = (cov_1v2gfocvar().s[26]++, (cov_1v2gfocvar().b[8][0]++, !performance) || (cov_1v2gfocvar().b[8][1]++, performance.finalDate));
  var isInFutureSalesPeriod;
  var salesStartDate;
  cov_1v2gfocvar().s[27]++;
  if (performance) {
    cov_1v2gfocvar().b[9][0]++;
    cov_1v2gfocvar().s[28]++;
    isInFutureSalesPeriod = (cov_1v2gfocvar().b[10][0]++, performance.notOnSales) && (cov_1v2gfocvar().b[10][1]++, !performance.restrictedAdv);
    cov_1v2gfocvar().s[29]++;
    salesStartDate = performance.salesStartDate;
  } else {
    cov_1v2gfocvar().b[9][1]++;
    cov_1v2gfocvar().s[30]++;
    isInFutureSalesPeriod = (cov_1v2gfocvar().b[11][0]++, product.notOnSales) && (cov_1v2gfocvar().b[11][1]++, !product.restrictedAdv);
    cov_1v2gfocvar().s[31]++;
    salesStartDate = product.salesStartDate;
  }
  cov_1v2gfocvar().s[32]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    productId: product.id,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 183,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 184,
      columnNumber: 7
    }
  }, (cov_1v2gfocvar().b[12][0]++, showTitle) && (cov_1v2gfocvar().b[12][1]++, /*#__PURE__*/_react.default.createElement(_ProductTitle.NonHeadingTitle, {
    textFontSize: productTitleFontSize,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 186,
      columnNumber: 11
    }
  }, _ProductHelper.default.getProductTitle({
    product: product,
    performance: performance,
    intl: intl,
    usePerformanceName: replaceProductNameByPerformance
  }))), (cov_1v2gfocvar().b[13][0]++, showTitle) && (cov_1v2gfocvar().b[13][1]++, productSubtitle) && (cov_1v2gfocvar().b[13][2]++, /*#__PURE__*/_react.default.createElement(_ProductTitle.SubTitle, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 195,
      columnNumber: 42
    }
  }, productSubtitle)), (cov_1v2gfocvar().b[14][0]++, showPrice) && (cov_1v2gfocvar().b[14][1]++, currencyCode) && (cov_1v2gfocvar().b[14][2]++, /*#__PURE__*/_react.default.createElement(PriceText, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 198,
      columnNumber: 13
    }
  }, (cov_1v2gfocvar().b[15][0]++, displayPlainAmount) && (cov_1v2gfocvar().b[15][1]++, !(0, _isNil.default)(plainAmount)) && (cov_1v2gfocvar().b[15][2]++, /*#__PURE__*/_react.default.createElement(_price.SimplePrice, {
    price: {
      currencyCode: currencyCode,
      amount: plainAmount
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 201,
      columnNumber: 19
    }
  })), (cov_1v2gfocvar().b[16][0]++, !displayPlainAmount) && (cov_1v2gfocvar().b[16][1]++, !(0, _isNil.default)(minAmount)) && (cov_1v2gfocvar().b[16][2]++, /*#__PURE__*/_react.default.createElement(_price.default, {
    currencyCode: currencyCode,
    minAmount: minAmount,
    labelFrom: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: "gravity.Product.priceFrom",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 208,
        columnNumber: 32
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 205,
      columnNumber: 19
    }
  })))), ((cov_1v2gfocvar().b[17][0]++, showDate) || (cov_1v2gfocvar().b[17][1]++, showTime)) && (cov_1v2gfocvar().b[17][2]++, /*#__PURE__*/_react.default.createElement(_ProductDate.default, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    showDate: showDate,
    showTime: showTime,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 214,
      columnNumber: 11
    }
  })), (cov_1v2gfocvar().b[18][0]++, isMatch) && (cov_1v2gfocvar().b[18][1]++, !finalDate) && (cov_1v2gfocvar().b[18][2]++, /*#__PURE__*/_react.default.createElement(_DateLabel.default, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 224,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Product.dateToBeConfirmed",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 225,
      columnNumber: 15
    }
  }))), (cov_1v2gfocvar().b[19][0]++, isInFutureSalesPeriod) && (cov_1v2gfocvar().b[19][1]++, salesStartDate) && (cov_1v2gfocvar().b[19][2]++, /*#__PURE__*/_react.default.createElement(OnSalesFrom, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 230,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Product.onSaleFrom",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 231,
      columnNumber: 15
    }
  }), ' ', /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
    value: salesStartDate,
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 232,
      columnNumber: 15
    }
  }))), (cov_1v2gfocvar().b[20][0]++, showDescription) && (cov_1v2gfocvar().b[20][1]++, /*#__PURE__*/_react.default.createElement(_utils.OverflowDetector, {
    target: (cov_1v2gfocvar().b[21][0]++, !themeQueries.EQUILIBRIUM) && (cov_1v2gfocvar().b[21][1]++, '.g-TextPreview'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 244,
      columnNumber: 11
    }
  }, function (_ref3) {
    var showAllContent = _ref3.showAllContent;
    cov_1v2gfocvar().f[6]++;
    cov_1v2gfocvar().s[33]++;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _utils2.isDisplayTooltip)(performance, product) ? (cov_1v2gfocvar().b[22][0]++, /*#__PURE__*/_react.default.createElement(TooltipWrapper, {
      mouseLeaveDelay: 0,
      placement: "bottom",
      overlay: htmlTooltip,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 248,
        columnNumber: 19
      }
    }, /*#__PURE__*/_react.default.createElement(ProductDescriptionTextPreview, {
      lines: showAllContent ? (cov_1v2gfocvar().b[23][0]++, null) : (cov_1v2gfocvar().b[23][1]++, 3),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 249,
        columnNumber: 21
      }
    }, description))) : (cov_1v2gfocvar().b[22][1]++, (cov_1v2gfocvar().b[24][0]++, description) && (cov_1v2gfocvar().b[24][1]++, /*#__PURE__*/_react.default.createElement(ProductDescriptionTextPreview, {
      lines: showAllContent ? (cov_1v2gfocvar().b[25][0]++, null) : (cov_1v2gfocvar().b[25][1]++, 3),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 255,
        columnNumber: 21
      }
    }, description))));
  }))));
}
cov_1v2gfocvar().s[34]++;
ProductCardDetails.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* a specific timeslot to display, if provided take the timeslotData in priority */
  timeslot: _product.TimeslotType,
  /* Show or hide the product title */
  showTitle: _propTypes.default.bool,
  /* Prevent to display date */
  showDate: _propTypes.default.bool,
  /* Prevent to display the time */
  showTime: _propTypes.default.bool,
  /* Show or hide the product description */
  showDescription: _propTypes.default.bool,
  /* Show or hide  the minimum product price */
  showPrice: _propTypes.default.bool,
  /* We need the currency to display the price */
  currencyCode: _propTypes.default.string,
  /* Product title font-size */
  productTitleFontSize: _propTypes.default.string,
  replaceProductNameByPerformance: _propTypes.default.bool,
  /** Type definitions for react-intl, using for dynamic message */
  intl: _reactIntl.intlShape.isRequired,
  /** Theme context */
  themeQueries: _utils.WithThemeQueriesType
};
cov_1v2gfocvar().s[35]++;
ProductCardDetails.defaultProps = {
  showDate: true,
  showTime: true,
  showTitle: true,
  showDescription: false,
  showPrice: false,
  currencyCode: null,
  performance: null,
  timeslot: null,
  productTitleFontSize: null,
  replaceProductNameByPerformance: false,
  themeQueries: (0, _defineProperty2.default)({}, _themeProvider.DEFAULT_THEME_CONTEXT.theme, true)
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)((0, _reactIntl.injectIntl)(ProductCardDetails)));